/**
 * схема колонок для таблицы ошибок импорта
 * @property {object} columns - колонки
 */
let schemeImport = {
    reportColumns: {
        row: '№ строки',
        address: 'Адрес',
        face: 'Сторона',
        date: 'Дата',
        city: 'Город',
        errors: 'Ошибка'
    }
};

export default schemeImport;